import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {


  constructor(private translate: TranslateService,private localStorageService: LocalStorageService) {
    super();
        
    
    this.translate.onLangChange.subscribe(() => {
      this.getTranslations();
    });

    this.getTranslations();
  }

  
  public getTranslations() {
    let label = this.localStorageService.get("lang");
    this.translate.currentLang=label;
    this.translate.get([
      'itemsPerPageLabel'

    ]).subscribe((translations) => {
      this.itemsPerPageLabel = translations['itemsPerPageLabel'];
      this.changes.next();
    });
  }
}
